import { createContext, Dispatch, FC, SetStateAction, useContext, useEffect, useMemo, useState } from "react";
import { Context } from "../../index";
import { useNavigate, useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import "../../pages/Project/Project.css";
import "../../component/styles/input.css";
import NameProject from "../../component/Project/NameProject/NameProject";
import Files from "../../component/Project/Files/Files";
import HistoryProject, { HISTORY_PAGE_SIZE } from "../../component/Project/HistoryProject/HistoryProject";
import Team, { ITeamFilter } from "../../component/Project/Team/Team";
import GeneralInformation from "../../component/Project/GeneralInformation/GeneralInformation";
import Tasks, { PAGE_SIZE } from "../../component/Project/Tasks/Tasks";
import { FilterOptionsExtented, SelectedOptions } from "../../models/FilterModels/IFilterModel";
import { AppContext } from "../../App";
import { IFunctionPermissions } from "../../common/api_interfaces/role/IFunctionPermissions";
import FunctionSystem from "../../models/functionCode/functionsSystem";
import { SEO } from "../../component/Helmet/HelmetSEO";
import Loader from "../../component/Shared/Loader/Loader";
import axios, { AxiosError } from "axios";
import { PROJECT_SETTINGS_DEFAULT } from "../../common/constants/ProjectConst";
import { IFilesDisplay } from "../../common/api_interfaces/files/IFilesDisplay";
import { IGetFilesDisplayData } from "../../common/api_interfaces/files/IGetFilesDisplayData";
import { IProjectGeneralInfo } from "../../common/api_interfaces/project/IProjectGeneralInfo";
import { IProjectProgressInfo } from "../../common/api_interfaces/project/IProjectProgressInfo";
import { IProjectHistoryDisplay } from "../../common/api_interfaces/history/IProjectHistoryDisplay";
import { IGetProjectHistoryDisplay } from "../../common/api_interfaces/history/IGetProjectHistoryDisplay";
import { IProjectHistoryFilter } from "../../common/api_interfaces/history/IProjectHistoryFilter";
import { ProjectSettings } from "../../common/api_interfaces/project/ProjectSettings";
import { ITeamMemberDisplay } from "../../common/api_interfaces/project/ITeamDisplay";
import { IGetTeamDisplay } from "../../common/api_interfaces/project/IGetTeamDisplay";
import { ITaskDisplay, ITasksDisplay } from "../../common/api_interfaces/task/ITaskDisplay.response";
import { IGetTaskFilter } from "../../common/api_interfaces/task/IGetTaskFilter";
import { IGetTasksDisplayData } from "../../common/api_interfaces/task/IGetTasksDisplayData.request";
import { IIParametrsFilter } from "../../common/api_interfaces/filter/IIParametrsFilter";
import { FunctionsAccessRequest } from "../../common/api_interfaces/role/FunctionsAccessRequest";
import { IFileFilters } from "../../common/api_interfaces/files/IFileFilters";
import { handleError } from "../../helpers/ErrorLib/handleError";
import { hasPermission } from "../../helpers/hasPermisson";
import { systemFunctions } from "../../common/enums/systemFunctions";
import { accessPermission } from "../../common/enums/accessPermission";

interface ProjectContextType {
    loadFiles: (filters: IFileFilters) => void;
    persons: ItemTeam[];
    roles: ItemTeam[];
    applyFiltersTeam: () => void;
    counterTasks: number;
    setCounterTasks: Dispatch<SetStateAction<number>>;
    counterTeam: number;
    setCounterTeam: Dispatch<SetStateAction<number>>;
    loadNameProjectData: () => void;
    sortAsc: boolean;
    setSortAsc: Dispatch<SetStateAction<boolean>>;
    skipTasks: number;
    setSkipTasks: Dispatch<SetStateAction<number>>;
    pageTeam: number;
    setPageTeam: Dispatch<SetStateAction<number>>;
    setScrollEndedTeam: Dispatch<SetStateAction<boolean>>;
    scrollEndedTasks: boolean;
    setScrollEndedTasks: Dispatch<SetStateAction<boolean>>;
    teamSearchText: string;
    setTeamSearchText: Dispatch<SetStateAction<string>>;
    filterOptionsTeam: FilterOptionsExtented | undefined;
    selectedOptionsTeam: SelectedOptions;
    setSelectedOptionsTeam: Dispatch<SetStateAction<SelectedOptions>>;
    taskSearchText: string;
    setTaskSearchText: Dispatch<SetStateAction<string>>;
    filterOptionsTask: FilterOptionsExtented | undefined;
    selectedOptionsTask: SelectedOptions;
    setSelectedOptionsTask: Dispatch<SetStateAction<SelectedOptions>>;
    setLoader: Dispatch<SetStateAction<boolean>>;
    handleRefreshPage: () => void;
    projectSettings: ProjectSettings;
}

export const ProjectContext = createContext<ProjectContextType>({} as ProjectContextType);

export interface ISort {
    date?: "asc" | "desc";
    status?: "asc" | "desc";
    responsible?: "asc" | "desc";
    type?: "asc" | "desc";
    priority?: "asc" | "desc";
    nameTask?: "asc" | "desc";
}

interface ItemTeam {
    name: string;
    code: string;
    status?: string;
}

export interface ISort {
    date?: "asc" | "desc";
    status?: "asc" | "desc";
    responsible?: "asc" | "desc";
    type?: "asc" | "desc";
    priority?: "asc" | "desc";
    nameTask?: "asc" | "desc";
}

interface ItemTeam {
    name: string;
    code: string;
}

const Project: FC = (index) => {
    const navigate = useNavigate();
    const { store } = useContext(Context);
    const { pageTitle, showToast } = useContext(AppContext);

    const { id } = useParams();
    //NAME PROJECT
    const [nameData, setNameData] = useState<IProjectGeneralInfo | undefined>(undefined);
    const [projectSettings, setProjectSettings] = useState<ProjectSettings>(PROJECT_SETTINGS_DEFAULT);
    //PROGRESS INFO
    const [progressData, setProgressData] = useState<IProjectProgressInfo | undefined>(undefined);
    //FILES
    const [files, setFiles] = useState<IFilesDisplay | undefined>(undefined);
    // const [filesFilterOptions, setFilesFilterOptions] = useState<IFileFilterOptions | undefined>(undefined);
    //HISTORY
    const [changes, setChanges] = useState<IProjectHistoryDisplay[]>([]);
    //TEAM
    const [team, setTeam] = useState<ITeamMemberDisplay[]>([]);
    const [scrollEndedTeam, setScrollEndedTeam] = useState(false);
    const [persons, setPersons] = useState<ItemTeam[]>([]);
    const [roles, setRoles] = useState<ItemTeam[]>([]);
    const [pageTeam, setPageTeam] = useState(1);

    //TASKS
    const [scrollEndedTasks, setScrollEndedTasks] = useState(false);
    const [tasks, setTasks] = useState<ITaskDisplay[]>([]);

    const [sortAsc, setSortAsc] = useState(false);
    const [skipTasks, setSkipTasks] = useState(0);
    // const [openTask, setOpenTask] = useState(false);

    //FILTERS
    const [filterOptionsTask, setFilterOptionsTask] = useState<FilterOptionsExtented>();
    const [filterOptionsTeam, setFilterOptionsTeam] = useState<FilterOptionsExtented>();

    const [teamSearchText, setTeamSearchText] = useState<string>("");
    const [taskSearchText, setTaskSearchText] = useState<string>("");

    const [selectedOptionsTask, setSelectedOptionsTask] = useState<SelectedOptions>({});
    const [selectedOptionsTeam, setSelectedOptionsTeam] = useState<SelectedOptions>({});

    const [counterTasks, setCounterTasks] = useState<number>(0);
    const [counterTeam, setCounterTeam] = useState<number>(0);

    const [userAccess, setUserAccess] = useState<IFunctionPermissions[]>([]);
    const [loader, setLoader] = useState<boolean>(false);

    const [projectId, setProjectId] = useState<number | undefined>(undefined);

    const userCanViewTasks = useMemo(
        () => userAccess && hasPermission(userAccess, systemFunctions.TaskAction, accessPermission.view),
        [userAccess]
    );

    const fieldFilterTasks: IIParametrsFilter = {
        projectId: projectId,
        projectUser: true,
        taskStatus: true,
        taskType: true,
        taskPriority: true,
    };

    const fieldFilterTeams: IIParametrsFilter = {
        projectId: projectId,
        role: true,
    };

    useEffect(() => {
        if (id === undefined || isNaN(Number(id)) || Number(id) <= 0) {
            return;
        }

        setProjectId(Number(id));
    }, [id]);

    //Ограничение доступа
    useEffect(() => {
        (async () => {
            try {
                const functionClass = new FunctionSystem();
                const newCheckRole: FunctionsAccessRequest = {
                    projectId: projectId ?? null,
                    boardId: null,
                    functionCodes: nameData?.isArchived
                        ? functionClass.getAppFunction
                        : functionClass.getProjectFunction,
                };

                const checkThisRole = await store.hasPermission(newCheckRole);
                setUserAccess(checkThisRole);
            } catch (error) {
                console.error(error);
            }
        })();
    }, [projectId]);

    //NAME PROJECT FUNCTIONS
    const loadNameProjectData = async (): Promise<IProjectGeneralInfo | null | number> => {
        if (!projectId) {
            return null;
        }

        let res = await store.getProjectGeneralInfo(projectId);
        if (typeof res !== "string" && typeof res !== undefined) {
            setNameData(res as IProjectGeneralInfo);
        }
        return res;
    };

    useEffect(() => {
        loadAllProjectData();
    }, [projectId, userAccess]);

    const handleRefreshPage = () => {
        loadAllProjectData();
    };

    const loadAllProjectData = () => {
        if (!projectId || !userAccess) {
            return;
        }

        setSkipTasks(0);
        setScrollEndedTasks(false);

        setPageTeam(1);
        setScrollEndedTeam(false);

        loadNameProjectData()
            .then((res) => {
                if (!res) {
                    console.error("Ошибка");
                }
                if (res === 404) {
                    navigate("/projects");
                }
                if (typeof res !== "number") setNameData(res!);
            })
            .catch((error) => {
                showToast("Ошибка загрузки данных!");
            });

        (async () => {
            try {
                await loadProjectProgressData();
                await loadFiles({
                    projectId: projectId,
                    name: "",
                    fileType: [],
                });
                await loadTeamMembers();
                await loadProjectSettings();
                setSkipTasks(PAGE_SIZE);
                await loadTasks(0, PAGE_SIZE, {});
                await loadSystemPersonWithRoles();
                await loadChanges(0, HISTORY_PAGE_SIZE, undefined, false);
                await getFilterData(fieldFilterTasks, "task");
                await getFilterData(fieldFilterTeams, "team");
            } catch (error) {
                console.error(error);
            }
        })();

        store.setCurrentProjectId(projectId);
    };

    const loadProjectSettings = async () => {
        if (!projectId) {
            return;
        }

        if (!id || isNaN(projectId)) {
            return;
        }

        try {
            const res = await store.projectService.getProjectSettings(projectId);
            setProjectSettings(res.data);
        } catch (ex: any) {
            if (axios.isAxiosError(ex)) {
                console.error(ex.response?.data.message);
            }
        }
    };

    const loadSystemPersonWithRoles = async () => {
        await store.getSystemPersonWithRoles();
        if (store.personsWithRoles && store.personsWithRoles.person && store.personsWithRoles.roles) {
            let personsData: ItemTeam[] = [];
            let rolesdata: ItemTeam[] = [];
            store.personsWithRoles.person.forEach((i) => {
                let item = {
                    name: String(
                        i?.surname +
                            (i?.name?.length ? " " + i?.name?.slice(0, 1) + "." : "") +
                            (i?.middlename?.length ? "" + i?.middlename?.slice(0, 1) + "." : "")
                    ),
                    code: i.id.toString(),
                };
                personsData.push(item);
            });

            store.personsWithRoles.roles.forEach((i) => {
                let item = {
                    name: i?.name,
                    code: i?.id?.toString(),
                };
                rolesdata.push(item);
            });

            setPersons([...personsData]);
            setRoles([...rolesdata]);
        }
    };

    //PROJECT PROGRESS INFO
    const loadProjectProgressData = async () => {
        if (!projectId) {
            return;
        }

        let res = await store.getProjectProgressData(projectId);
        setProgressData(res!);
    };
    //FILES FUNCTIONS
    const loadFiles = async (filters: IFileFilters) => {
        try {
            const req: IGetFilesDisplayData = { filters };
            const response = await store.fileService.getFilesDisplayData(req);

            setFiles(response.data);
        } catch (error: any) {
            handleError(error, {
                defaultMessage: "Неизвестная ошибка при получении файлов",
                showToast: showToast,
            });
        }
    };

    //HISTORY FUNCTIONS
    const loadChanges = async (
        skip: number,
        take: number,
        filters: IProjectHistoryFilter | undefined,
        append: boolean
    ): Promise<boolean> => {
        if (!projectId) {
            return false;
        }

        let req: IGetProjectHistoryDisplay = {
            skip: skip,
            take: take,
            filters: filters ?? {
                projectId: projectId,
            },
            sort: {
                date: "desc",
            },
        };

        const res = await store.getProjectHistoryDisplayData(req);
        if (Array.isArray(res)) {
            if (append) setChanges([...changes, ...res]);
            else setChanges(res);
        }
        return res.length > 0;
    };

    //TODO add appendTasks
    //TEAM FUNCTIONS
    const loadTeamMembers = async () => {
        if (!projectId) {
            return;
        }

        const filters: ITeamFilter = {
            projectId: projectId,
            role: selectedOptionsTeam?.roleIds,
            name: teamSearchText.length > 0 ? teamSearchText : undefined,
        };

        const newPageReq: IGetTeamDisplay = {
            filters: filters,
        };

        try {
            const res = await store.projectService.getProjectTeamDisplayData(newPageReq);
            setTeam(res.data.team);
        } catch (error: any) {
            console.error(error?.response?.data.message);
        }
    };

    const handleUpdateFiltersTeam = async () => {
        setScrollEndedTeam(false);
        await loadTeamMembers();
    };

    //TASK FUNCTIONS
    const loadTasks = async (skip: number, take: number, sort: ISort) => {
        if (!projectId || !userCanViewTasks) {
            return;
        }

        const filters: IGetTaskFilter = {
            projectId: projectId,
            responsible: selectedOptionsTask.responsibleIds,
            date: selectedOptionsTask.dates?.map((d) => d.toISOString()),
            taskId: undefined,
            status: selectedOptionsTask.statusIds,
            priority: selectedOptionsTask.priorityIds,
            typeTask: selectedOptionsTask.typeTaskIds,
            name: taskSearchText.length > 0 ? taskSearchText : undefined,
        };

        setScrollEndedTasks(false);
        const newPageReq: IGetTasksDisplayData = {
            skip: skip,
            take: take,
            filters: filters,
            sort: sort,
        };

        try {
            const response = await store.taskService.getProjectTasksDisplayData(newPageReq);
            setTasks(response.data.tasks);
        } catch (err: any) {
            if (axios.isAxiosError(err)) {
                showToast(err.response!.data.message);
            }
            setTasks([]);
        }
    };
    const appendTasks = async (skip: number, take: number, sort: ISort) => {
        if (!projectId) {
            return;
        }

        const filters: IGetTaskFilter = {
            projectId: projectId,
            responsible: selectedOptionsTask.responsibleIds,
            date: selectedOptionsTask.dates?.map((d) => d.toISOString()),
            taskId: undefined,
            status: selectedOptionsTask.statusIds,
            priority: selectedOptionsTask.priorityIds,
            typeTask: selectedOptionsTask.typeTaskIds,
            name: taskSearchText.length > 0 ? taskSearchText : undefined,
        };

        const newPageReq: IGetTasksDisplayData = {
            skip: skip,
            take: take,
            filters: filters,
            sort: sort,
        };

        try {
            const response = await store.taskService.getProjectTasksDisplayData(newPageReq);
            const res = response.data as ITasksDisplay;
            if (res?.tasks && res?.tasks?.length > 0) {
                setTasks((prev) => [...prev, ...res.tasks]);
            } else {
                setScrollEndedTasks(true);
            }
        } catch (err: any) {
            if (err instanceof AxiosError) {
                showToast(err.response!.data.message);
            }
            setScrollEndedTasks(true);
        }
    };
    const handleLoadPageTasks = async (skip: number, take: number, sort: ISort) => {
        await appendTasks(skip, take, sort);
    };

    const getFilterData = async (body: IIParametrsFilter, typeFilter: "team" | "task") => {
        try {
            const response = await store.filterService.getFilters(body);
            const data = response.data;

            if (typeFilter === "task") {
                const options: FilterOptionsExtented = {
                    responsible: data.projectUsers,
                    priority: data.taskPriority,
                    typeTask: data.taskType,
                    status: data.taskStatus,
                };
                setFilterOptionsTask(options);
            } else if (typeFilter === "team") {
                const options: FilterOptionsExtented = {
                    role: data.role,
                };
                setFilterOptionsTeam(options);
            }
        } catch (error: any) {
            if (axios.isAxiosError(error)) {
                showToast(error.response?.data?.message, error.response?.data?.details);
            }
        }
    };

    const applyFiltersTeam = async () => {
        setPageTeam(1);
        setScrollEndedTeam(false);
        await loadTeamMembers();
    };

    return (
        <ProjectContext.Provider
            value={{
                loadFiles,
                persons,
                roles,
                applyFiltersTeam,
                counterTasks,
                setCounterTasks,
                counterTeam,
                setCounterTeam,
                loadNameProjectData,
                sortAsc,
                setSortAsc,
                skipTasks,
                setSkipTasks,
                pageTeam,
                setPageTeam,
                setScrollEndedTeam,
                scrollEndedTasks,
                setScrollEndedTasks,
                teamSearchText,
                setTeamSearchText,
                filterOptionsTeam,
                selectedOptionsTeam,
                setSelectedOptionsTeam,
                taskSearchText,
                setTaskSearchText,
                filterOptionsTask,
                selectedOptionsTask,
                setSelectedOptionsTask,
                setLoader,
                handleRefreshPage,
                projectSettings: projectSettings ?? PROJECT_SETTINGS_DEFAULT,
            }}
        >
            <SEO title={nameData ? nameData.projectName + " | Проект · " + pageTitle : pageTitle} />
            {loader ? <Loader /> : null}
            <div className="widgets_container" style={{ position: "relative" }}>
                <div className="widgets_container_column_left">
                    <div className="widgets-container-block">
                        <NameProject
                            data={nameData}
                            loadNameProjectData={async () => {
                                await loadNameProjectData();
                                await loadProjectProgressData();
                                await loadProjectSettings();
                            }}
                            userAccess={userAccess}
                        />
                    </div>
                    <div className="widgets-container-block">
                        <Files
                            files={files}
                            // filterOptions={filesFilterOptions}
                            updateFilters={loadFiles}
                            userAccess={userAccess}
                        />
                    </div>
                    <div className="widgets-container-block">
                        <HistoryProject records={changes} loadPage={loadChanges} userAccess={userAccess} />
                    </div>
                </div>
                <div className="widgets_container_column_right">
                    <div className="widgets-container-block">
                        <Team
                            members={team}
                            scrollEnded={scrollEndedTeam}
                            updateFilters={handleUpdateFiltersTeam}
                            loadTeamMembers={loadTeamMembers}
                            userAccess={userAccess}
                        />
                    </div>
                    <div className="widgets-container-block">
                        {projectId && <GeneralInformation data={progressData} projectId={projectId} />}
                    </div>
                    <div className="widgets-container-block">
                        <Tasks
                            tasks={tasks}
                            scrollEnded={scrollEndedTasks}
                            loadPage={handleLoadPageTasks}
                            loadTasks={loadTasks}
                            userAccess={userAccess}
                        />
                    </div>
                    {/* 
                    
                     */}
                </div>
            </div>
        </ProjectContext.Provider>
    );
};

export default observer(Project);
